// Client environment metadata sent with brand compliance submissions so the
// Workfront issue records what browser/OS the submitter used.
export interface ClientEnvironment {
  browserName: string;
  browserVersion: string;
  operatingSystem: string;
  userAgentString: string;
}

// Order matters: Edge/Opera/Samsung UAs also contain a "Chrome/x" token, and
// Chrome/Safari UAs both contain "Safari", so the more specific patterns come first.
const BROWSER_PATTERNS: Array<{ name: string; pattern: RegExp }> = [
  { name: "Edge", pattern: /Edg(?:e|A|iOS)?\/([\d.]+)/ },
  { name: "Opera", pattern: /OPR\/([\d.]+)/ },
  { name: "Samsung Internet", pattern: /SamsungBrowser\/([\d.]+)/ },
  { name: "Firefox", pattern: /(?:Firefox|FxiOS)\/([\d.]+)/ },
  { name: "Chrome", pattern: /(?:Chrome|CriOS)\/([\d.]+)/ },
  { name: "Safari", pattern: /Version\/([\d.]+).*Safari/ },
];

// iOS before macOS (iPhone/iPad UAs contain "like Mac OS X"); Android and
// Chrome OS before Linux (their UAs contain "Linux").
const OS_PATTERNS: Array<{ name: string; pattern: RegExp }> = [
  { name: "iOS", pattern: /iPhone|iPad|iPod/ },
  { name: "Android", pattern: /Android/ },
  { name: "Windows", pattern: /Windows/ },
  { name: "macOS", pattern: /Mac OS X/ },
  { name: "Chrome OS", pattern: /CrOS/ },
  { name: "Linux", pattern: /Linux/ },
];

export function getClientEnvironment(): ClientEnvironment {
  const userAgentString = navigator.userAgent;

  const browser = BROWSER_PATTERNS.find(({ pattern }) => pattern.test(userAgentString));
  const os = OS_PATTERNS.find(({ pattern }) => pattern.test(userAgentString));

  return {
    browserName: browser?.name ?? "Unknown",
    browserVersion: browser?.pattern.exec(userAgentString)?.[1] ?? "",
    operatingSystem: os?.name ?? "Unknown",
    userAgentString,
  };
}
